import { ActionTypes } from "../constants/action-types";

const initialState = {
  newFaq: [],
};

export const UploadFaq = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.UPLOAD_FAQ:
      return { ...state, newFaq: payload };
    default:
      return state;
  }
};
